import React from 'react';
import { Button } from '@jem-open/jem-ui';
import { Trash2 } from 'lucide-react';
import { useMultiProductRecon } from '../MultiProductReconContext';
import ProductSelector from './ProductSelector';

interface ReconGroupFormProps {
  reconId: string;
  isOnlyRecon: boolean;
}

const ReconGroupForm = ({ reconId, isOnlyRecon }: ReconGroupFormProps) => {
  const { removeRecon } = useMultiProductRecon();

  return (
    <div className="space-y-6 pt-3">
      <ProductSelector reconId={reconId} />

      {!isOnlyRecon && (
        <div className="flex justify-end border-t pt-3">
          <Button
            variant="ghost"
            leftIcon={<Trash2 className="size-4" />}
            onClick={() => removeRecon(reconId)}
          >
            Remove this recon
          </Button>
        </div>
      )}
    </div>
  );
};

export default ReconGroupForm;
